export class AppActionBar extends HTMLElement {
  connectedCallback() {
    this.classList.add("action-bar");
  }
}

if (!customElements.get("app-action-bar")) {
  if (!customElements.get("app-action-bar")) {
    customElements.define("app-action-bar", AppActionBar);
  }
}
